import React, { JSX, lazy, Suspense } from 'react';

const LazypropertyDetailPage = lazy(() => import('./[id]'));

const PropertyDetailPage = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode }) => (
  <Suspense fallback={
    <div className="min-h-80">
  
  </div>
  
  }> 
    {/* <LazypropertyDetailPage {...props} /> */}
  </Suspense>
);

export default PropertyDetailPage;
